import React from "react";
import { CustomLink } from "@/components/CustomLink.tsx";
import styles from "../SitemapModule.module.scss";
import { SitemapGroup } from "@/getData/getSitemapData.ts";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.tsx";
import { optimizeURL } from "@/utils/url.ts";

interface SitemapSectionProps {
  group: SitemapGroup;
  isNobleElements: boolean;
}

export const SitemapSection = ({
  group,
  isNobleElements,
}: SitemapSectionProps) => {
  const { getIcon } = useGlobalContext();
  const labelParts = group.label.split(" > ");

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>
        {labelParts.map((part, i) => (
          <React.Fragment key={i}>
            {i > 0 && (
              <CustomSVG
                src={getIcon("arrow") || "/arrow.svg"}
                wrapper="span"
                width={8}
                height={13}
                aria-hidden="true"
                className={styles["title-arrow"]}
              />
            )}
            {part}
          </React.Fragment>
        ))}
      </h3>
      <div className={styles.grid}>
        {group.items.map((item, index) => (
          <div key={index}>
            <CustomLink
              href={optimizeURL(item.link, isNobleElements)}
              target={"_self"}
            >
              <span dangerouslySetInnerHTML={{ __html: item.title }} />
            </CustomLink>
          </div>
        ))}
      </div>
    </div>
  );
};
